/**
 * SectionHeader — a page / section title row with an optional subtitle and a
 * right-aligned action slot.
 */

import type { ReactNode } from 'react';

interface SectionHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  /** Right-aligned slot — typically buttons or a control. */
  action?: ReactNode;
}

export default function SectionHeader({ title, subtitle, action }: SectionHeaderProps) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3">
      <div>
        <h1 className="text-[22px] font-semibold font-headline text-on-surface tracking-tight">
          {title}
        </h1>
        {subtitle && <p className="text-sm text-outline mt-1">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
